import { useMutation } from "@tanstack/react-query";
import axios from "axios";

export default function useChangePassword() {
  return useMutation({
    mutationFn: ({
      payload,
    }: {
      payload: {
        token: string;
        newPassword: string;
        confirmPassword: string;
      };
    }) =>
      axios({
        url: "/auth/change-password-first-login",
        baseURL: `${import.meta.env.VITE_SERVER_URI}`,
        method: "post",
        data: payload,
      }),
  });
}
